document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-cf-box-build]').forEach((builder) => {
    const maxPoints = parseInt(builder.dataset.maxPoints || '0', 10);
    const form = builder.querySelector('[data-cf-box-form]');
    const barFill = builder.querySelector('[data-cf-points-fill]');
    const pointsUsedEl = builder.querySelector('[data-cf-points-used]');
    const pointsRemainEl = builder.querySelector('[data-cf-points-remaining]');
    const noteEl = builder.querySelector('[data-cf-box-note]');
    const addBtn = builder.querySelector('[data-cf-add-box]');
    const cadenceSelect = builder.querySelector('[data-cf-selling-plan]');
    const items = [...builder.querySelectorAll('[data-cf-item]')];

    const money = (cents) => {
      return (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: Shopify.currency.active || 'USD'
      });
    };

    const getState = () => {
      let points = 0;
      const chosen = [];

      items.forEach((item) => {
        const qtyEl = item.querySelector('[data-cf-qty]');
        const qty = parseInt(qtyEl.value || '0', 10);
        const pointsEach = parseInt(item.dataset.points || '0', 10);
        const variantId = item.dataset.variantId;
        const title = item.dataset.title;

        if (qty > 0) {
          points += qty * pointsEach;
          chosen.push({ qty, pointsEach, variantId, title });
        }
      });

      return {
        points,
        remaining: maxPoints - points,
        chosen
      };
    };

    const render = () => {
      const state = getState();
      const pct = maxPoints > 0 ? Math.min((state.points / maxPoints) * 100, 100) : 0;

      pointsUsedEl.textContent = state.points;
      pointsRemainEl.textContent = Math.max(state.remaining, 0);
      barFill.style.width = `${pct}%`;

      if (state.points === 0) {
        noteEl.textContent = `Choose your cuts to build your box.`;
      } else if (state.remaining > 0) {
        noteEl.textContent = `You still have ${state.remaining} point${state.remaining === 1 ? '' : 's'} left.`;
      } else if (state.remaining === 0) {
        noteEl.textContent = `Perfect. Your box is full and ready to add.`;
      } else {
        noteEl.textContent = `You are over by ${Math.abs(state.remaining)} point${Math.abs(state.remaining) === 1 ? '' : 's'}. Remove an item to continue.`;
      }

      addBtn.disabled = state.points === 0 || state.remaining < 0;
    };

    items.forEach((item) => {
      const minus = item.querySelector('[data-cf-minus]');
      const plus = item.querySelector('[data-cf-plus]');
      const qtyEl = item.querySelector('[data-cf-qty]');
      const pointsEach = parseInt(item.dataset.points || '0', 10);

      minus.addEventListener('click', () => {
        let qty = parseInt(qtyEl.value || '0', 10);
        qty = Math.max(0, qty - 1);
        qtyEl.value = qty;
        render();
      });

      plus.addEventListener('click', () => {
        let qty = parseInt(qtyEl.value || '0', 10);
        const state = getState();
        if ((state.points + pointsEach) <= maxPoints) {
          qty += 1;
          qtyEl.value = qty;
          render();
        } else {
          noteEl.textContent = `That selection would push the box over ${maxPoints} points.`;
        }
      });
    });

    addBtn.addEventListener('click', async () => {
      const state = getState();
      if (state.points === 0 || state.remaining < 0) return;

      const baseVariantId = builder.dataset.baseVariantId;
      const sellingPlan = cadenceSelect && cadenceSelect.value ? cadenceSelect.value : null;
      const baseTitle = builder.dataset.baseTitle || 'Membership Box';

      const itemsPayload = [
        {
          id: parseInt(baseVariantId, 10),
          quantity: 1,
          ...(sellingPlan ? { selling_plan: parseInt(sellingPlan, 10) } : {}),
          properties: {
            "_Credence Box Builder": "Yes",
            "_Box Contents": state.chosen.map(x => `${x.qty}x ${x.title}`).join(', '),
            "_Points Used": `${state.points}/${maxPoints}`
          }
        }
      ];

      state.chosen.forEach((x) => {
        itemsPayload.push({
          id: parseInt(x.variantId, 10),
          quantity: x.qty,
          properties: {
            "_Bundled With": baseTitle
          }
        });
      });

      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      try {
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: itemsPayload })
        });

        if (!res.ok) throw new Error('Cart add failed');

        window.location.href = `${window.Shopify.routes.root}cart`;
      } catch (err) {
        console.error(err);
        noteEl.textContent = 'Something went wrong adding the box. Please try again.';
        addBtn.disabled = false;
        addBtn.textContent = 'Add box to cart';
      }
    });

    render();
  });
});